module.exports = __webpack_public_path__ + "static/media/notFound.9f04c388.svg";